import { isAppsRustAuth0TokenRefreshDesktopEnabled } from '@/features/flags/rust-auth0-token-refresh-desktop';
import { getDomains } from '@/helpers/getDomains';
import { getAuthTokenForHttpClientSync } from '@/utils/http/getAuthTokenForHttpClientSync';
import { X_CLIENT_ID } from '@/utils/scribeHTTP';
import { getTempUserId } from '@/utils/tempUser';
import { getWorkspaceId } from '@heidi/workspace/data';

import type { RecorderUploadAuthContext, RecorderUploadMetadata } from './upload-types';

export function buildRecorderUploadMetadata(
  baseV2Url = getDomains().baseV2Url
): RecorderUploadMetadata {
  const normalizedBaseV2Url = baseV2Url.replace(/\/$/, '');
  return {
    uploadUrl: `${normalizedBaseV2Url}/rpa/recordings`,
    workspaceId: getWorkspaceId() ?? null,
    tempUserId: getTempUserId() ?? null,
    clientId: X_CLIENT_ID,
    rustAuth0TokenRefresh: isAppsRustAuth0TokenRefreshDesktopEnabled(),
  };
}

export function buildDefaultUploadAuthContext(): RecorderUploadAuthContext {
  const bearer = getAuthTokenForHttpClientSync();
  return {
    ...buildRecorderUploadMetadata(),
    bearerToken: bearer ?? null,
  };
}
